import { emptyObj, getRequestData } from '@/utils';
import cloneDeep from 'lodash/cloneDeep';
import {
  qrySubsGroupInfoBsnl,
  qrySubsCallHuntingNbrBsnl,
  qryFellowNbrType4FMCBsnl,
  qryFellowNbrType4FNFBsnl,
  qryFellowNbrBsnl,
  setVasBsnl,
  qryAvailableRelateOfferBsnl,
  manageSubsGroupInfoBsnl,
  manageSubsCallHuntingNbrBsnl,
} from '@/pages/ModifyingFixedLineNumberGroup/services/modifyingFixedLineNumberGroup';

export default {
  namespace: 'modifyingFixedLineNumberGroup',
  state: {
    step: 0, // 变更固话群组业务流程的步骤
    searchCustInfo: {}, // 从搜索页面同步过来的用户信息
    serviceType: {}, // 从搜索页面同步过来的服务类型
    subServiceType: {}, // 从搜索页面同步过来的子服务类型
    activeTabsKey: '', // 当前选中Tab
    centrex: {}, // 储存centrexTab数据
    callHunting: {}, // 储存callHunting数据
    cug: {}, // 储存cug数据
    fmc: {}, // 储存fmc数据
    fnf: {}, // 储存fnf数据
    featureList: [], // 可订购vas列表
    centrexGroupList: [], // 当前订户centrex列表
    cugGroupList: [], // 当前订户cug列表
    callHuntingNbrList: [], // 当前订户的callHunting列表
    fellowNbrTypeFMCList: [], // FMC Group Type 下拉框
    fellowNbrTypeFNFList: [], // FNF Group Type 下拉框
    fmcMenLimit: 0, // fmc号码长度限制
    fellowNbrFMCList: [], // FMC号码列表
    fellowNbrFNFList: [], // FNF号码列表
  },
  effects: {
    *qrySubsGroupInfoBsnl({ payload }, { call, put }) {
      const response = yield call(qrySubsGroupInfoBsnl, payload);
      const { centrexGroupDtoList, cugGroupDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          centrexGroupList: centrexGroupDtoList,
          cugGroupList: cugGroupDtoList,
        },
      });
    },

    *qrySubsCallHuntingNbrBsnl({ payload }, { call, put }) {
      const response = yield call(qrySubsCallHuntingNbrBsnl, payload);
      const { callHuntingNbrDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          callHuntingNbrList: callHuntingNbrDtoList,
        },
      });
    },

    *qryFellowNbrType4FMCBsnl(_, { call, put }) {
      const response = yield call(qryFellowNbrType4FMCBsnl);
      const { fellowNbrTypeDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          fellowNbrTypeFMCList: fellowNbrTypeDtoList || [],
        },
      });
      const fellowNbrTypeIdArr = (fellowNbrTypeDtoList || []).map(element => element.fellowNbrTypeId);
      return fellowNbrTypeIdArr.join(',');
    },

    *qryFellowNbrType4FNFBsnl(_, { call, put }) {
      const response = yield call(qryFellowNbrType4FNFBsnl);
      const { fellowNbrTypeDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          fellowNbrTypeFNFList: fellowNbrTypeDtoList || [],
        },
      });
      const fellowNbrTypeIdArr = (fellowNbrTypeDtoList || []).map(element => element.fellowNbrTypeId);
      return fellowNbrTypeIdArr.join(',');
    },

    *qryFellowNbr4FMCBsnl({ payload }, { call, put }) {
      const response = yield call(qryFellowNbrBsnl, payload);
      const { fellowNbrDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          fellowNbrFMCList: fellowNbrDtoList,
        },
      });
    },

    *qryFellowNbr4FNFBsnl({ payload }, { call, put }) {
      const response = yield call(qryFellowNbrBsnl, payload);
      const { fellowNbrDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          fellowNbrFNFList: fellowNbrDtoList,
        },
      });
    },

    *qryAvailableRelateOfferBsnl({ payload }, { call, put }) {
      const response = yield call(qryAvailableRelateOfferBsnl, payload);
      const { offerDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          featureList: offerDtoList,
        },
      });
    },

    *setVasBsnl({ payload }, { call }) {
      const response = yield call(setVasBsnl, payload);
      return getRequestData(response);
    },

    *manageSubsGroupInfoBsnl({ payload }, { call }) {
      // 前端批量新增修改号码组
      const response = yield call(() => Promise.all(payload.map(element => manageSubsGroupInfoBsnl(element))));
      const dataArr = response.map(element => getRequestData(element));
      return dataArr;
    },

    *manageSubsCallHuntingNbrBsnl({ payload }, { call }) {
      // 前端批量新增修改号码组
      const response = yield call(() => Promise.all(payload.map(element => manageSubsCallHuntingNbrBsnl(element))));
      const dataArr = response.map(element => getRequestData(element));
      return dataArr;
    },
  },
  reducers: {
    tabsSave(state, { payload, activeTabsKey }) {
      const tabState = { ...state[activeTabsKey], ...payload };
      state[activeTabsKey] = cloneDeep(tabState);
      return {
        ...state,
      };
    },
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear(state) {
      return emptyObj(state);
    },
  },
};
